





















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import UpfrontContributionBase from "@/employee/components/onboarding/upfront-contribution/UpfrontContributionBase.vue";
import LinkedAccounts from "@/employee/components/shared/LinkedAccounts.vue";
import { OnboardingBalanceTransfer, OnboardingContribution } from "@/employee/route-names";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    Button,
    GenericLoadingSpinner,
    UpfrontContributionBase,
    LinkedAccounts
  }
})
export default class OnboardingLinkedAccounts extends Vue {
  bankAccountStore = useBankAccountStore();
  themeStore = useThemeStore();

  mounted () {
    this.bankAccountStore.loadBankAccountState();
  }

  onSkip () {
    this.$router.push({
      name: OnboardingBalanceTransfer
    });
  }

  onContinue () {
    this.$router.push({
      name: OnboardingContribution
    });
  }

  get isLoading (): boolean {
    return this.bankAccountStore.linkedAccountIsLoading;
  }

  get skipDisabled (): boolean {
    return this.bankAccountStore.isLinkedCardIframeLoading
    || this.bankAccountStore.isAchVerifierUrlLoading
    || this.hasValidLinkedAccount;
  }

  get continueDisabled (): boolean {
    return !this.hasValidLinkedAccount;
  }

  get hasValidLinkedAccount () {
    return this.bankAccountStore.hasAtLeastOneLinkedAccount && !this.bankAccountStore.isAnyAccountsInVerificationFailedState;
  }
}
